import React, { useState, useId } from "react";
import { cn } from "@/lib/utils";
import { Eye, EyeOff } from "lucide-react";

export const GlassInput = React.forwardRef(
    (
        {
            label,
            error,
            type = "text",
            prefix,
            suffix,
            className = "",
            testId,
            id: idProp,
            togglePassword = false,
            ...rest
        },
        ref,
    ) => {
        const autoId = useId();
        const id = idProp || autoId;
        const [revealed, setRevealed] = useState(false);
        const realType = togglePassword ? (revealed ? "text" : "password") : type;
        return (
            <div className={cn("w-full", className)}>
                {label && (
                    <label
                        htmlFor={id}
                        className="block text-xs font-medium text-[color:var(--slate-mid)] mb-1.5 tracking-wide uppercase"
                    >
                        {label}
                    </label>
                )}
                <div className="relative">
                    {prefix && (
                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--slate-light)] pointer-events-none">
                            {prefix}
                        </span>
                    )}
                    <input
                        id={id}
                        ref={ref}
                        type={realType}
                        data-testid={testId}
                        className={cn(
                            "glass-input",
                            prefix && "pl-10",
                            (suffix || togglePassword) && "pr-10",
                            error && "input-error",
                        )}
                        {...rest}
                    />
                    {togglePassword ? (
                        <button
                            type="button"
                            onClick={() => setRevealed((v) => !v)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-[color:var(--slate-light)] hover:text-[color:var(--copper)] transition-colors"
                            data-testid={testId ? `${testId}-toggle` : undefined}
                            tabIndex={-1}
                        >
                            {revealed ? <EyeOff size={18} strokeWidth={1.6} /> : <Eye size={18} strokeWidth={1.6} />}
                        </button>
                    ) : suffix ? (
                        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[color:var(--slate-light)]">
                            {suffix}
                        </span>
                    ) : null}
                </div>
                {error && (
                    <p className="mt-1.5 text-xs text-[color:var(--error)] font-body">{error}</p>
                )}
            </div>
        );
    },
);

GlassInput.displayName = "GlassInput";
